import { mediaItems } from '@/mocks/home';

export default function SectionMedia() {
  return (
    <section id="media" className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
              精彩看点
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {mediaItems.map((item) => (
              <a
                key={item.id}
                href="#media"
                className="group relative bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-accent-200 transition-all duration-300 cursor-pointer"
              >
                <div className="aspect-[16/9] overflow-hidden relative">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-3 flex items-center justify-between">
                    <span className="flex items-center gap-1.5 text-white/90 text-xs">
                      <i className="ri-play-circle-fill text-base"></i>
                      {item.views}
                    </span>
                    <span className="px-2 py-0.5 bg-black/50 text-white/90 text-[10px] rounded font-mono">
                      {item.duration}
                    </span>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="text-sm font-medium text-foreground-800 group-hover:text-accent-600 transition-colors line-clamp-2 leading-snug">
                    {item.title}
                  </h3>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}